import {cva} from 'platform/shared';

import {ForwardedRef, ReactNode, forwardRef} from 'react';

import {Nullish, TestIdProps} from 'shared/web';

export interface PlatformInputWrapperProps extends TestIdProps {
  children: ReactNode;
  isDisabled: boolean | Nullish;
  isInvalid: boolean | Nullish;
  isRecommended: boolean | Nullish;
  onClick?: VoidFunction;
}

const inputWrapperVariants = cva(
  'flex h-8 max-h-8 min-h-0 w-full items-center overflow-hidden rounded-[var(--radius-small)] border border-[var(--color-palettes-neutral-70-100)] bg-[var(--color-white)] px-2 text-[var(--color-primary)] focus-within:border-[var(--color-severity-informational)] focus-within:bg-[var(--color-white)] focus-within:[box-shadow:var(--shadow-active)]',
  {
    variants: {
      isDisabled: {
        true: 'cursor-not-allowed border-[var(--color-palettes-neutral-70-40)] bg-[var(--color-palettes-white-10-40)] shadow-none',
        false: 'hover:border-[var(--color-severity-informational)] hover:bg-[var(--color-white)]',
      },
      isInvalid: {
        true: 'border-[var(--color-severity-danger)]',
        false: '',
      },
      isRecommended: {
        true: 'bg-[var(--color-palettes-orange-10-100)]',
        false: '',
      },
    },
    defaultVariants: {
      isDisabled: false,
      isInvalid: false,
      isRecommended: false,
    },
  }
);

/**
 * @private
 * This component is a platform only bulding block
 * Do not use this anywhere outside of platform
 */
export const PlatformInputWrapper = forwardRef(PlatformInputWrapperComponent);
function PlatformInputWrapperComponent(
  props: PlatformInputWrapperProps,
  ref: ForwardedRef<HTMLDivElement>
) {
  return (
    <div
      ref={ref}
      onClick={props.onClick}
      className={inputWrapperVariants({
        isDisabled: !!props.isDisabled,
        isInvalid: !!props.isInvalid,
        isRecommended: !!props.isRecommended && !props.isInvalid,
      })}
    >
      {props.children}
    </div>
  );
}
